import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsWishComponent } from './simple-icons-wish.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsWishComponent ],
    exports:      [ SimpleIconsWishComponent ],
    bootstrap:    []
})
export class SimpleIconsWishModule {}
